var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M461.913,133.565H50.087C22.468,133.565,0,156.033,0,183.652v37.69l183.652,73.59v-44.497 c0-9.223,7.479-16.696,16.696-16.696h111.304c9.217,0,16.696,7.473,16.696,16.696v44.497L512,221.342v-37.69 C512,156.033,489.532,133.565,461.913,133.565z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.043,
    y: 267.13,
    width: 77.913,
    height: 33.391
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.043,
    y: 333.913,
    width: 77.913,
    height: 33.391
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.348,330.894V384c0,9.223-7.479,16.696-16.696,16.696H200.348c-9.217,0-16.696-7.473-16.696-16.696v-53.106L0,257.305 v204.609C0,489.532,22.468,512,50.087,512h411.826C489.532,512,512,489.532,512,461.913V257.305L328.348,330.894z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.348,0H183.652c-46.032,0-83.478,37.446-83.478,83.478v16.696h100.174V66.783h111.304v33.391h100.174V83.478 C411.826,37.446,374.38,0,328.348,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/experienceIcon.a5116754a4321e6a7d16a688bfcec715.svg";
export { ForwardRef as ReactComponent };